import "./style.css";
import { e as n, T as c, g as i, a as l } from "./index-up0O4QOR.js";
const p = (e) => `v-on:${e.toLowerCase()}`, f = (e, t) => (r) => n({
  code: e,
  context: t.context,
  localState: t.localState,
  rootState: t.rootState,
  rootSetState: t.rootSetState,
  event: r,
  isExpression: !1
});
function g(e) {
  const t = {}, r = e.block.actions ?? {};
  for (const o in r) {
    if (!r.hasOwnProperty(o))
      continue;
    const s = r[o];
    let a = p(o);
    if (e.stripPrefix)
      switch (c) {
        case "vue":
          a = a.replace("v-on:", "");
          break;
        case "svelte":
          a = a.replace("on:", "");
          break;
      }
    t[a] = f(s, e);
  }
  return t;
}
function u({
  properties: e
}) {
  return e;
}
const v = (e) => ({
  href: e.href
});
function m({
  block: e,
  context: t
}) {
  var o;
  const r = {
    ...v(e),
    ...e.properties,
    "builder-id": e.id,
    style: i({
      block: e,
      context: t
    }),
    [l()]: [e.id, "builder-block", e.class, (o = e.properties) == null ? void 0 : o.class].filter(Boolean).join(" ")
  };
  return u({
    properties: r,
    context: t,
    block: e
  });
}
export {
  m as a,
  g
};
